// extracted by mini-css-extract-plugin
export default {"tag":"BX2cX","info":"P9adA","default":"rTTdE","text":"c61kl","success":"Z_brz","error":"p0cfX"};